import * as React from 'react';
import {loadModules} from 'esri-loader';
import $ from 'jquery';

export default class LayerList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            layerList: null,
            layerState: {}
        };
    }

    flattenDeep(arr1) {
        return arr1.reduce((acc, val) => Array.isArray(val) ? acc.concat(this.flattenDeep(val)) : acc.concat(val), []);
    }

    getLayers(l) {
        const self = this;
        return l.items.map((ll) => {
            if (ll.hasOwnProperty('layer') && ll.sublayers == null && ll.layer.type === 'kml') {
                if (ll.visible) {
                    return ll.id
                } else {
                    return null;
                }
            } else {
                if (ll.hasOwnProperty('layers')) {
                    return self.getLayers(ll.layers);
                } else if(ll.hasOwnProperty('sublayers')){
                    let result = self.getLayers(ll.sublayers);

                    if(ll.parent !== null && ll.visible){
                        if(Array.isArray(result)){
                            result.push(ll.id)
                        } else {
                            result = ll.id
                        }
                    }
                    return result;
                }  else {
                    if (ll.visible) {
                        return ll.layerId
                    } else {
                        return null;
                    }
                }
            }
        });
    }

    render() {
        return null;
    }

    getRootParent = (layer) => {
        if (layer.parent !== null) {
            return this.getRootParent(layer.parent)
        } else {
            return layer;
        }
    };

    componentDidMount() {
        const self = this;
        loadModules(['esri/widgets/LayerList']).then(([LayerList]) => {
            let layerList = new LayerList({
                id: 'layer_list_comp',
                view: this.props.view,
                listItemCreatedFunction: (event) => {
                    if (Array.isArray(self.props.visibleLayers)) {
                        this.setState({layerState: self.props.visibleLayers});
                        const item = event.item;
                        const parent = self.getRootParent(item);
                        let layer = self.props.visibleLayers.find((i) => i.id === parent.layer.id);
                        if (layer) {
                            if (item.parent === null) {
                                item.layer.visible = layer.visible;
                            } else {
                                if (item.layer.hasOwnProperty('layerId')) {
                                    item.layer.visible = layer.visibleSubLayers.includes(item.layer.layerId)
                                } else if (item.layer.hasOwnProperty('id')) {
                                    item.layer.visible = layer.visibleSubLayers.includes(item.layer.id)
                                }
                            }
                        }
                    }
                }
            });

            self.setState({layerList});

            self.props.view.ui.add(layerList, {
                position: 'bottom-right'
            });

            $(layerList.domNode).on('click', (e) => {
                const result = layerList.operationalItems.items.map((item) => {
                    let visibleLayers = [];
                    if (item.layer.hasOwnProperty('layers')) {
                        visibleLayers = self.flattenDeep(self.getLayers(item.layer.layers)).filter((l) => l !== null)
                    } else if (item.layer.hasOwnProperty('sublayers')) {
                        visibleLayers = self.flattenDeep(self.getLayers(item.layer.sublayers)).filter((l) => l !== null)
                    }
                    return {
                        id: item.layer.id,
                        visible: item.visible,
                        type: item.layer.type,
                        visibleSubLayers: visibleLayers
                    }
                });
                self.setState({layerState: result});
                self.props.onChange(result);
            })
        }).catch((err) => console.error(err));
    }

    componentWillUnmount() {
        this.props.view.ui.remove(this.state.layerList);
    }
}

LayerList.defaultProps = {
    onChange: (result) => {
    }
};
